import { MutationTree } from "vuex";
import { SearchConditionState, SET_SEARCH_CONDITION } from "./types";
import { SearchCondition } from "@/types";

export const mutations: MutationTree<SearchConditionState> = {
  [SET_SEARCH_CONDITION](state, searchCondition: SearchCondition) {
    state.searchCondition = searchCondition;
  }
};
